var _style, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotificationEmailStandard = function SvgIconNotificationEmailStandard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.8 17.6",
    style: {
      enableBackground: "new 0 0 24.8 17.6"
    },
    xmlSpace: "preserve",
    width: 26.194,
    height: 17.996,
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#11526A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-785.813 -554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(785.812 549.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.312 12.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,5.1c-0.1,0-0.2,0-0.3-0.1l-4.6-4.3c-0.2-0.1-0.2-0.4-0.1-0.6c0.1-0.2,0.4-0.2,0.6-0.1c0,0,0,0,0,0 L16,4.4c0.2,0.2,0.2,0.4,0,0.6C15.9,5.1,15.8,5.1,15.7,5.1L15.7,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,5.1C0.2,5.1,0,4.9,0,4.7c0-0.1,0-0.2,0.1-0.3l4.6-4.3c0.1-0.2,0.4-0.2,0.6,0c0.2,0.1,0.2,0.4,0,0.6 c0,0,0,0,0,0L0.7,5C0.6,5.1,0.5,5.1,0.4,5.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,22.1H2c-1.1,0-2-0.9-2-2V6.5c0-1.1,0.9-2,2-2h20.8c1.1,0,2,0.9,2,2v13.6C24.8,21.2,23.9,22.1,22.8,22.1 z M2,5.3c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0,0,0v13.6c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0,0h20.8c0.7,0,1.2-0.5,1.2-1.2v0V6.5 c0-0.7-0.5-1.2-1.2-1.2c0,0,0,0,0,0L2,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,15.3c-0.5,0-1.1-0.2-1.5-0.5L0.7,5.8C0.5,5.7,0.4,5.4,0.6,5.3C0.7,5.1,1,5,1.1,5.2c0,0,0,0,0.1,0 l10.3,8.9c0.5,0.4,1.3,0.4,1.9,0l10.2-8.9c0.2-0.2,0.4-0.2,0.6,0s0.2,0.4,0,0.6c0,0,0,0,0,0l-10.2,8.9 C13.4,15.1,12.9,15.3,12.4,15.3z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotificationEmailStandard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification_email_standard.06103b62.svg";
export { ForwardRef as ReactComponent };